import { lazy } from "react";
import SalesForAutoCare from "./Sales/POS/salesForAutoCare";
import GeneralLedger from "./AccountDetails/GeneralLedger/GeneralLedger";
import JournalTypes from "./AccountDetails/JounralTypesAccount/JournalTypes";
import SupplierReports from "./Reports/ReportsComponents/Supplier";
// import { useSelector } from "react-redux";
// import { authRoles } from "../auth";
// import AutoLogout from "./AutoLogout";

const Transfer = lazy(() => import("./Store/Transfer/stockTransfer"));
const Quotation = lazy(() => import("./Store/Quotation/salesQuotation"));
const Dashboard = lazy(() => import("./Dashboard/dashboard"));
const Customer = lazy(() => import("./Customer/customer"));
const Suppliers = lazy(() => import("./Suppliers/Supplier/suppliers"));
const Expenses = lazy(() => import("./Expenses/expenses"));
// const ExpensesType = lazy(() => import("./Expenses/ExpensesCategory/expensesCategory"));
const ExpansesCategory = lazy(()=>import("./Expenses/ExpensesCategory/expensesCategory"))
const CreditAndDebit = lazy(() => import("./AccountDetails/CreditAndDebit/CreditAndDebit"))
const EntryTypesAccount = lazy(() => import("./AccountDetails/JounralTypesAccount/JournalTypes"))
const Reports = lazy(() => import("./Reports/reports"));
const Settings = lazy(() => import("./Settings/settings"));
const ItemMaster = lazy(() => import("./Stock/Item_Master/itemMaster"));
const Bin = lazy(() => import("./Stock/Bin/bin"));
const ItemCategory = lazy(() => import("./Stock/Category/category"));
const SalesRep = lazy(() => import("./SalesRep/salesRep"));
const SalesBoys = lazy(() => import("./SalesBoys/SalesBoys"));
const Users = lazy(() => import("./Users/users"));
const UserType = lazy(() => import("./Users/User-Type/userType"));
//const Sales = lazy(() => import("./Sales/POS/salesWithPackSize"));
const Sales = lazy(() => import("./Sales/POS/sales"));
//const InvoiceReversal = lazy(() => import("./InvoiceReversal/Reversal"))
const Barcode = lazy(() => import("./Barcode/barcode"));
const Route = lazy(() => import("./SalesRep/Route/route"));
const Colour = lazy(() => import("./Stock/Colour/colour"));
const Brand = lazy(() => import("./Stock/Brand/brand"));
const Unit = lazy(() => import("./Stock/Unit/unit"));
const Size = lazy(() => import("./Stock/Size/size"));
const Grn = lazy(() => import("./Store/GRN/grn"));
const StockIn = lazy(() => import("./Store/StockIn/StockIn"));
const stockDashboard = lazy(()=>import("./Store/StockDashBoard/stockDashBoard"))
const matureStock = lazy(() => import("./Store/MatureStock/MatureStock"));
const Cheques = lazy(() => import("./Cheque/chequeInHand"));
const ProcessingCheques = lazy(() => import("./Cheque/ChequeDeposit"));
const ThirdPartyCheque = lazy(()=>(import("./Cheque/ThirdpartyCheque")))
const ReturnedCheques = lazy(() => import("./Cheque/returnedCheques"));
const StockIssue = lazy(() => import("./Store/Stock-Issue/stockIssue"));
const SalesOrder = lazy(() => import("./Store/SalesOrder/salesOrder"));
const PurchaseReturn = lazy(() =>
  import("./Suppliers/PurchaseReturn/purchaseReturn")
);
const SalesReturn = lazy(() => import("./Customer/SalesReturn/salesReturn"));
const Reversal = lazy(() => import("./Reversal/reversal"));

const PaymentReceipt = lazy(() =>
  import("./Customer/Payment-receipt/paymentReceipt")
);

const PaymentVouchers = lazy(() =>
  import("./Suppliers/PaymentVouchers/paymentVouchers")
);

const ChequeVoucher = lazy(() => import("./ChequeVoucher/chequeInHand"));
const ChequeVoucherInProcess = lazy(() => import("./ChequeVoucher/chequesInProcess"));
const ReturnedChequeVoucher = lazy(() => import("./ChequeVoucher/returnedCheques"));
const ReturnChequePayment = lazy(() => import("./Cheque/ReturnChequePayment/ReturnChequePayment"));
const ChequeRealized = lazy(() => import("./Cheque/ChequRealized"))
const PaidGrn = lazy(() => import("./Store/GRN/paidGrn"));
const UpComingServices = lazy(() => import("./Vehicle/upCommingServices"));
const Vehicle = lazy(() => import("./Vehicle/Vehicle"));
const ServicePack = lazy(() =>
  import("./Vehicle/Service-packages/servicePackages")
);
//const stockFreeze = lazy(()=> import("./StockFreeze/stockFreeze"));
const StockFreeze = lazy(()=>(import("./StockFreeze/stockFreeze")));
const ListOfInvoice = lazy(()=>import("./Sales/POS/ListOfInvoice"));
const ListOfSavedInvoice = lazy(()=>import('./Sales/POS/ListOfSavedInvoice'))

//Reports Routing
const SupplierListReport = lazy(() =>import("./Reports/ReportsComponents/Supplier/supplierList"));
const DebitStatement = lazy(() =>import("./Reports/ReportsComponents/Supplier/debitStatement"));
const SupplierSummery = lazy(() =>import("./Reports/ReportsComponents/Supplier/SupplierSummery"));
// const PeriodicVoucher = lazy(() =>import("./Reports/ReportsComponents/Supplier/PeriodicVoucher"));
const paymentVoucher = lazy(() =>import("./Reports/ReportsComponents/Supplier/DailyVoucherByPaymentType"));

const PurchaseList = lazy(() =>import("./Reports/ReportsComponents/Purchase/purchaseList"));
const DailyPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/dailyPurchase"));
const DetailPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/detailsPurchase"));
const MonthlyPurchase = lazy(() =>import("./Reports/ReportsComponents/Purchase/monthlyPurchase"));

const StockInHand = lazy(() =>import("./Reports/ReportsComponents/Stock/stockInhand"));
const StockAudit = lazy(() =>import("./Reports/ReportsComponents/Stock/stockAudit"));
const ItemInStock = lazy(() =>import("./Reports/ReportsComponents/Stock/itemInStock"));
const PeriodicStock = lazy(() =>import("./Reports/ReportsComponents/Stock/periodicStock"));
const StockIssues = lazy(() =>import("./Reports/ReportsComponents/Stock/stockIssue"));
const StockInHandQuantity = lazy(() =>import("./Reports/ReportsComponents/Stock/totalQuantity"));

const DailySummary = lazy(() =>import("./Reports/ReportsComponents/Summary/dailySummary"));
const MonthlySummary = lazy(() =>import("./Reports/ReportsComponents/Summary/monthlySummary"));
const PeriodicSummary = lazy(() =>import("./Reports/ReportsComponents/Summary/periodicSummary"));
const DayEnd = lazy(() =>import("./Reports/ReportsComponents/Summary/dayEnd"));
const DayEndByUser = lazy(() =>import("./Reports/ReportsComponents/Summary/DayEndByUser"));
//const LedgerAudit = lazy(()=>import("./Reports/ReportsComponents/Summary/LedgerAudit"));
const LedgerDetailSummery = lazy(()=>import("./Reports/ReportsComponents/Summary/ledgerDetailsSummary"));
const LedgerAudit = lazy(()=>import("./Reports/ReportsComponents/Summary/LedgerAudit"))

// const CustomerReport = lazy(() =>import("./Reports/ReportsComponents/Customers/customerReport"));
const CustomerReport = lazy(() =>import("./Reports/ReportsComponents/Customers/listOfCustomer"));
const CustomerSummary = lazy(() =>import("./Reports/ReportsComponents/Customers/customerSummary"));
const CreditStatement = lazy(() =>import("./Reports/ReportsComponents/Customers/creditStatement"));
const CreditStatementRoute = lazy(() =>import("./Reports/ReportsComponents/Customers/CreditStatmentByRoute"));
const CreditStatementRep = lazy(() =>import("./Reports/ReportsComponents/Customers/CreditStatmentByRep"));

const DailySales = lazy(() =>import("./Reports/ReportsComponents/Sales/dailySales"));
const DetailsSales = lazy(() =>import("./Reports/ReportsComponents/Sales/detailsSales"));
const MonthlySales = lazy(() =>import("./Reports/ReportsComponents/Sales/monthlySales"));
const PeriodicSales = lazy(() =>import("./Reports/ReportsComponents/Sales/periodicSales"));
const SalesMargin = lazy(() =>import("./Reports/ReportsComponents/Sales/salesMargin"));
const DailySalesReturn = lazy(() =>import("./Reports/ReportsComponents/Sales/salesReturn"));
const DailySalesWithPayment = lazy(() =>import("./Reports/ReportsComponents/Sales/DailySaleswithPayment"));
const CustomerSalesReconsalation = lazy(() =>import("./Reports/ReportsComponents/Sales/CustomerReconciliation"));
const PeriodicSavedInvoice = lazy(() =>import("./Reports/ReportsComponents/Sales/SavedInvoice"));
const salesBySalesboys = lazy(()=>import("./Reports/ReportsComponents/Sales/salesBySalesSalesboys"));
const dailySalesSummary = lazy(() =>import("./Reports/ReportsComponents/Sales/dailySalesSummary"));



const DailyExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/dailyExpenses"));
const MonthlyExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/monthlyExpenses"));
const PeriodicExpenses = lazy(() =>import("./Reports/ReportsComponents/Expenses/periodicExpenses"));

const ChequeByCustomer = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/chequeByCustomer"));
const ChePeriodicExpenses = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/periodicChequ"));
const perVoucher = lazy(() =>import("./Reports/ReportsComponents/Supplier/PeriodicVoucher"));
const DailyCheques = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/dailyCheque"));
const ChequeInHand = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeInHand"));
const ChequeDeposited = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeDeposit"));
const ChequeRealize = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeRealized"));
const ChequeReturned = lazy(() =>import("./Reports/ReportsComponents/ChequeReceipt/ChequeRetuned"));
const ChequeBySalesRep = lazy(()=>import("./Reports/ReportsComponents/ChequeReceipt/ChequeReceiptByRep"))

const ChequeBySupplier = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/chequeBySupplier"));
// const ChePeriodicCheque = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/c"));
const DailyChequeVoucher = lazy(() =>import("./Reports/ReportsComponents/ChequeVoucher/dailyCheque"));

const DailyPaymentReceipt = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/dailyPaymentReceipt"));
const PaymentReceiptByRep = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByRep"));
const PaymentReceiptByRoute = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByRoute"));
const PaymentReceiptByLocation = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/paymentReceiptByLocation"));
const ReceiptbyPayment = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/dailyReceiptByPaymentype"));
// const PayChequeReturned = lazy(() =>import("./Reports/ReportsComponents/PaymentReceipt/"));
const SalesForSms = lazy(() => import("./Sales/POS/salesForSms"));

//End of reports routing 

// export const cashierRouteConfig = {
//   settings: {},
//   auth: ["admin","superAdmin", "cashier"],
//   routes: [
//     { path: "/sales", component: Sales },
//     { path: "/dashboard", component: Dashboard },
//     { path: "/customer", component: Customer },
//     { path: "/matureStock", component: matureStock },
//     { path: "/grn", component: Grn },
//     { path: "/stock-issue", component: StockIssue },
//     { path: "/stock-transfer", component: Transfer },
//     { path:"/stock-in", component: StockIn },
//     { path: "/sales-auto-care", component: SalesForAutoCare },
//     { path: "/barcode", component: Barcode },
//     { path: "/service-pack", component: ServicePack },
//     { path: "/vehicle", component: Vehicle },
//     { path: "/upcoming-service", component: UpComingServices },
//     { path:"/stock-dashboard" , component:stockDashboard},
//     { path: "/sales-quotation", component: Quotation },
//     { path: "/suppliers", component: Suppliers },
//     { path: "/supplier-list", component: SupplierListReport },
//     //{ path: "/auto-logout", component: AutoLogout },
    
//     //{ path: "/invoice-reversal", component: InvoiceReversal },
//     { path: "/cheques", component: Cheques },
//     {path:"/third-party-cheque" , component:ThirdPartyCheque},
//     { path: "/returned-cheque", component: ReturnedCheques },
//     { path: "/cheques-process", component: ProcessingCheques },
//     { path: "/sales-order", component: SalesOrder },
//     { path: "/salesRep", component: SalesRep },
//     { path: "/expenses", component: Expenses },
//     // { path: "/expenses-type", component: ExpensesType },
//     { path: "/expanses-category", component:ExpansesCategory},
//     { path: "/credit-and-debit", component: CreditAndDebit },
//     { path: "/journal-types", component: JournalTypes },
//     { path: "/general-ledger", component: GeneralLedger },
//     { path: "/item-master", component: ItemMaster },
//     { path: "/item-category", component: ItemCategory },
//     { path: "/user", component: Users },
//     { path: "/user-type", component: UserType },
//     { path: "/sales-return", component: SalesReturn },
//     { path: "/reversal", component: Reversal },
//     { path: "/payment-vouchers", component: PaymentVouchers },
//     { path: "/route", component: Route },
//     { path: "/item-bin", component: Bin },
//     { path: "/item-colour", component: Colour },
//     { path: "/item-brand", component: Brand },
//     { path: "/item-unit", component: Unit },
//     // { path: "/grn", component: Grn },
//     { path: "/grn-paid", component: PaidGrn },
//     { path: "/chequePayment", component: ReturnChequePayment },  
//     { path: "/settings", component: Settings },
//     { path: "/purchase-return", component: PurchaseReturn },
//     { path: "/cheque-vouchers", component: ChequeVoucher },
//     { path: "/cheque-vouchers-process", component: ChequeVoucherInProcess },
//     { path: "/returned-cheque-vouchers", component: ReturnedChequeVoucher },
//     { path:"/cheque-realized", component: ChequeRealized },
//     { path: "/payment-receipt", component: PaymentReceipt },
//     { path: "/reports/supplier-list", component: SupplierListReport },
//     {path:"/stock-freeze", component:StockFreeze},
//     {path:"/reports" , component:Reports},

// // ---------------------------For Report - Supplier--------------------------------
//     { path: "/supplier-list", component: SupplierListReport },
//     { path: "/debit-statement", component: DebitStatement },
//     { path: "/supplier-summery", component: SupplierSummery },
//     { path: "/periodic-voucher", component: PeriodicVoucher },
//     { path: "/payment-voucher", component: paymentVoucher },

// // ---------------------------For Report - Purchase--------------------------------
//     { path: "/purchase-list", component: PurchaseList },
//     { path: "/daily-purchase", component: DailyPurchase },
//     { path: "/detail-purchase", component: DetailPurchase },
//     { path: "/monthly-purchase", component: MonthlyPurchase },

// // ---------------------------For Report - Stock--------------------------------
//     { path: "/stock-in-hand", component: StockInHand },
//     { path: "/stock-audit", component: StockAudit },
//     { path: "/item-in-stock", component: ItemInStock },
//     { path: "/periodic-stock", component: PeriodicStock },
//     { path: "/stock-issues", component: StockIssues },
//     { path: "/stock-in-hand-quantity", component: StockInHandQuantity },


// // ---------------------------For Report - Summary--------------------------------
//     { path: "/daily-summary", component: DailySummary },
//     { path: "/monthly-summary", component: MonthlySummary },
//     { path: "/periodic-summary", component: PeriodicSummary },
//     { path: "/day-end", component: DayEnd },
//     { path: "/day-end-by-user", component: DayEndByUser },

// // ---------------------------For Report - Customer--------------------------------
//     { path: "/customer-report", component: CustomerReport },
//     { path: "/customer-summary", component: CustomerSummary },
//     { path: "/credit-statement", component: CreditStatement },
//     { path: "/credit-statement-route", component: CreditStatementRoute },
//     { path: "/credit-statement-rep", component: CreditStatementRep },

// // ---------------------------For Report - Sales--------------------------------
//     { path: "/daily-sales", component: DailySales },
//     { path: "/details-sales", component: DetailsSales },
//     { path: "/monthly-sales", component: MonthlySales },
//     { path: "/periodic-sales", component: PeriodicSales },
//     { path: "/sales-margin", component: SalesMargin },
//     { path: "/daily-sales-return", component: DailySalesReturn },
//     { path: "/daily-sales-with-payment", component: DailySalesWithPayment },
//     { path: "/customer-sales-reconsalation", component: CustomerSalesReconsalation },

//  // ---------------------------For Report - Expenses--------------------------------
//     { path: "/daily-expenses", component: DailyExpenses },
//     { path: "/monthly-expenses", component: MonthlyExpenses },
//     { path: "/periodic-expenses", component: PeriodicExpenses },
    
//  // ---------------------------For Report - Cheque:Reciept--------------------------------
//     { path: "/cheque-by-customer", component: ChequeByCustomer },
//     { path: "/che-periodic-expenses", component: ChePeriodicExpenses },
//     { path: "/daily-cheques", component: DailyCheques },   
//     { path: "/cheque-in-hand", component: ChequeInHand },
//     { path: "/cheque-deposited", component: ChequeDeposited },
//     { path: "/cheque-realize", component: ChequeRealize },
//     { path: "/cheque-returned", component: ChequeReturned },

// // ---------------------------For Report - Cheque:Voucher--------------------------------
//     { path: "/cheque-by-supplier", component: ChequeBySupplier },
//     { path: "/che-periodic-expenses", component: ChePeriodicExpenses },
//     { path: "/daily-cheque-voucher", component: DailyChequeVoucher },   

// // ---------------------------For Report - PaymentReceipt--------------------------------
//     { path: "/daily-payment-receipt", component: DailyPaymentReceipt },
//     { path: "/payment-receipt-by-rep", component: PaymentReceiptByRep },
//     { path: "/payment-receipt-by-route", component: PaymentReceiptByRoute },   
//     { path: "/payment-receipt-by-location", component: PaymentReceiptByLocation },
//     { path: "/cheque-returned", component: ChequeReturned },    
//   ],
// };

export const authorisedRouteConfig = {
  settings: {},
  auth: ["admin","cashier","manager","inventory manager","boss","accounter"],
  routes: [
    { path: "/sales", component: Sales },
    { path: "/sales-sms", component: SalesForSms },
    {path:"/list-of-invoice",component:ListOfInvoice},
    {path:'/list-of-saved-invoice',component:ListOfSavedInvoice},
    { path: "/dashboard", component: Dashboard },
    { path: "/customer", component: Customer },
    { path: "/matureStock", component: matureStock },
    { path: "/grn", component: Grn },
    { path: "/stock-issue", component: StockIssue },
    { path: "/stock-transfer", component: Transfer },
    { path:"/stock-in", component: StockIn },
    { path: "/sales-auto-care", component: SalesForAutoCare },
    { path: "/barcode", component: Barcode },
    { path: "/service-pack", component: ServicePack },
    { path: "/vehicle", component: Vehicle },
    { path: "/upcoming-service", component: UpComingServices },
    { path:"/stock-dashboard" , component:stockDashboard},
    { path: "/sales-quotation", component: Quotation },
    { path: "/suppliers", component: Suppliers },
    { path: "/supplier-list", component: SupplierListReport },
    //{ path: "/auto-logout", component: AutoLogout },
    //{ path: "/invoice-reversal", component: InvoiceReversal },
    { path: "/cheques", component: Cheques },
    {path:"/third-party-cheque" , component:ThirdPartyCheque},
    { path: "/returned-cheque", component: ReturnedCheques },
    { path: "/cheques-process", component: ProcessingCheques },
    { path: "/sales-order", component: SalesOrder },
    { path: "/salesRep", component: SalesRep },
    {path:"/sales-boys",component:SalesBoys},

    { path: "/expenses", component: Expenses },
    // { path: "/expenses-type", component: ExpensesType },
    { path: "/expanses-category", component:ExpansesCategory},
    { path: "/credit-and-debit", component: CreditAndDebit },
    { path: "/journal-types", component: JournalTypes },
    { path: "/general-ledger", component: GeneralLedger },
    { path: "/item-master", component: ItemMaster },
    { path: "/item-category", component: ItemCategory },
    { path: "/user", component: Users },
    { path: "/user-type", component: UserType },
    { path: "/sales-return", component: SalesReturn },
    { path: "/reversal", component: Reversal },
    { path: "/payment-vouchers", component: PaymentVouchers },
    { path: "/route", component: Route },
    { path: "/item-bin", component: Bin },
    { path: "/item-colour", component: Colour },
    { path: "/item-brand", component: Brand },
    { path: "/item-unit", component: Unit },
    { path: "/item-size",component:Size},
    // { path: "/grn", component: Grn },
    { path: "/grn-paid", component: PaidGrn },
    { path: "/chequePayment", component: ReturnChequePayment },  
    { path: "/settings", component: Settings },
    { path: "/purchase-return", component: PurchaseReturn },
    { path: "/cheque-vouchers", component: ChequeVoucher },
    { path: "/cheque-vouchers-process", component: ChequeVoucherInProcess },
    { path: "/returned-cheque-vouchers", component: ReturnedChequeVoucher },
    { path:"/cheque-realized", component: ChequeRealized },
    { path: "/payment-receipt", component: PaymentReceipt },
    { path: "/reports/supplier-list", component: SupplierListReport },
    {path:"/stock-freeze", component:StockFreeze},
    {path:"/reports" , component:Reports},

// ---------------------------For Report - Supplier--------------------------------
    { path: "/supplier-list", component: SupplierListReport },
    { path: "/debit-statement", component: DebitStatement },
    { path: "/supplier-summery", component: SupplierSummery },
    // { path: "/periodic-voucher", component: PeriodicVoucher },
    { path: "/payment-voucher", component: paymentVoucher },

// ---------------------------For Report - Purchase--------------------------------
    { path: "/purchase-list", component: PurchaseList },
    { path: "/daily-purchase", component: DailyPurchase },
    { path: "/detail-purchase", component: DetailPurchase },
    { path: "/monthly-purchase", component: MonthlyPurchase },

// ---------------------------For Report - Stock--------------------------------
    { path: "/stock-in-hand", component: StockInHand },
    { path: "/stock-audit", component: StockAudit },
    { path: "/item-in-stock", component: ItemInStock },
    { path: "/periodic-stock", component: PeriodicStock },
    { path: "/stock-issues", component: StockIssues },
    { path: "/stock-in-hand-quantity", component: StockInHandQuantity },


// ---------------------------For Report - Summary--------------------------------
    { path: "/daily-summary", component: DailySummary },
    { path: "/monthly-summary", component: MonthlySummary },
    { path: "/periodic-summary", component: PeriodicSummary },
    { path: "/day-end", component: DayEnd },
    { path: "/day-end-by-user", component: DayEndByUser },
    {path:"/ledger-detail-summery", component:LedgerDetailSummery},
    {path:"/ledger-audit" ,component:LedgerAudit},
 
// ---------------------------For Report - Customer--------------------------------
    { path: "/customer-report", component: CustomerReport },
    { path: "/customer-summary", component: CustomerSummary },
    { path: "/credit-statement", component: CreditStatement },
    { path: "/credit-statement-route", component: CreditStatementRoute },
    { path: "/credit-statement-rep", component: CreditStatementRep },

// ---------------------------For Report - Sales--------------------------------
    { path: "/daily-sales", component: DailySales },
    { path: "/details-sales", component: DetailsSales },
    { path: "/monthly-sales", component: MonthlySales },
    { path: "/periodic-sales", component: PeriodicSales },
    { path: "/periodic-saved-invoice", component: PeriodicSavedInvoice },
    { path: "/sales-margin", component: SalesMargin },
    { path: "/daily-sales-return", component: DailySalesReturn },
    { path: "/daily-sales-with-payment", component: DailySalesWithPayment },
    { path: "/customer-sales-reconsalation", component: CustomerSalesReconsalation },
    { path:"/sales-by-sales-boys" , component:salesBySalesboys},
    { path: "/daily-sales-summary", component: dailySalesSummary },
 // ---------------------------For Report - Expenses--------------------------------
    { path: "/daily-expenses", component: DailyExpenses },
    { path: "/monthly-expenses", component: MonthlyExpenses },
    { path: "/periodic-expenses", component: PeriodicExpenses },
    
 // ---------------------------For Report - Cheque:Reciept--------------------------------
    { path: "/cheque-by-customer", component: ChequeByCustomer },
    { path: "/che-periodic-expenses", component: ChePeriodicExpenses },
    { path: "/daily-cheques", component: DailyCheques },   
    { path: "/cheque-in-hand", component: ChequeInHand },
    { path: "/cheque-deposited", component: ChequeDeposited },
    { path: "/cheque-realize", component: ChequeRealize },
    { path: "/cheque-returned", component: ChequeReturned },
    { path: "/cheque-by-salesRep", component: ChequeBySalesRep },

    

// ---------------------------For Report - Cheque:Voucher--------------------------------
    { path: "/cheque-by-supplier", component: ChequeBySupplier },
    { path: "/periodic-voucher", component: perVoucher },
    { path: "/daily-cheque-voucher", component: DailyChequeVoucher },   

// ---------------------------For Report - PaymentReceipt--------------------------------
    { path: "/daily-payment-receipt", component: DailyPaymentReceipt },
    { path: "/payment-receipt-by-rep", component: PaymentReceiptByRep },
    { path: "/payment-receipt-by-route", component: PaymentReceiptByRoute },   
    { path: "/payment-receipt-by-location", component: PaymentReceiptByLocation },
    { path: "/payment-receipt-by-type", component: ReceiptbyPayment },
    { path: "/cheque-returned", component: ChequeReturned },   
  ],
};